export default __webpack_public_path__ + "static/proviotics-product-b6b8e9eae09eef824de8fe7b2bd68a17.png";